import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import Label from '../Label/Label';
import styles from './LabelBox.module.scss';
import { firstLetterUpperCase } from '../../helpers';
import { MembersType } from '../../store/reducers/Guild/guildType';
import Paragraph from '../Typography/Paragraph/Paragraph';
import cn from 'classnames';
import { useTranslation } from 'react-i18next';
export const displayName = (name, address) => {
    if (!address)
        return name;
    if (name)
        return `${name} #${address === null || address === void 0 ? void 0 : address.slice(6, 10)}`;
    return `Equine User #${address.slice(6, 10)}`;
};
const LabelBox = ({ member, onClick }) => {
    const { t } = useTranslation();
    const displayLabelName = (member) => {
        if (member.type === MembersType.MEMBER) {
            if (member.member.guildBan) {
                return firstLetterUpperCase(t('banned'));
            }
            return;
        }
        return firstLetterUpperCase(member.type);
    };
    return (_jsxs("div", Object.assign({ "data-testid": "labelBox", onClick: onClick, className: cn(styles.element, 'd-flex align-items-center') }, { children: [_jsx(Paragraph, { fontFamily: 'marope', size: 1, title: displayName(member.member.name, member.member.address || '') }), _jsx(Label, { type: displayLabelName(member) === 'Banned' ? 3 : 1, className: styles.label, text: displayLabelName(member) || '' })] })));
};
export default LabelBox;
